import {type} from '../../common/utils';
import {IeDsFolder, IUserInfo} from "../../models/user-info";


export class ApplicationUserInfoActions {

  static ActionType = {
    SET_USER_PROJECTS: type('[ApplicationUserInfoActions] SET_USER_PROJECTS'),
    SET_EXAMPLE_PROJECTS: type('[ApplicationUserInfoActions] SET_EXAMPLE_PROJECTS'),
    SET_USER: type('[ApplicationUserInfoActions] SET_USER'),
    SET_CURRENT_USER_FOLDER: type('[ApplicationUserInfoActions] SET_CURRENT_USER_FOLDER'),
    SET_CURRENT_EXAMPLE_FOLDER: type('[ApplicationUserInfoActions] SET_CURRENT_EXAMPLE_FOLDER'),
    LOAD_FILE_SYSTEMS: type('[ApplicationUserInfoActions] LOAD_FILE_SYSTEMS'),
    LOAD_USER_LOGGED: type('[ApplicationUserInfoActions] LOAD_USER_LOGGED'),
    LOADING_USER_DATA: type('[ApplicationUserInfoActions] LOADING_USER_DATA'),
    LOAD_USER_DATA_COMPLETED: type('[ApplicationUserInfoActions] LOAD_USER_DATA_COMPLETED'),
    LOGIN_USER: type('[ApplicationUserInfoActions] LOGIN_USER'),
  };

  public static setUserProjects(db: IeDsFolder[]) {
    return {type: ApplicationUserInfoActions.ActionType.SET_USER_PROJECTS, payload: db};
  }

  public static setExampleProjects(db: IeDsFolder[]) {
    return {type: ApplicationUserInfoActions.ActionType.SET_EXAMPLE_PROJECTS, payload: db};
  }

  public static setUser(usr: IUserInfo) {
    return {type: ApplicationUserInfoActions.ActionType.SET_USER, payload: usr};
  }

  public static setCurrentUserFolder(f: IeDsFolder) {
    return {type: ApplicationUserInfoActions.ActionType.SET_CURRENT_USER_FOLDER, payload: f};
  }

  public static setCurrentExampleFolder(f: IeDsFolder) {
    return {type: ApplicationUserInfoActions.ActionType.SET_CURRENT_EXAMPLE_FOLDER, payload: f};
  }

  public static loadFileSystems() {
    return {type: ApplicationUserInfoActions.ActionType.LOAD_FILE_SYSTEMS};
  }

  public static loadUserLogged() {
    return {type: ApplicationUserInfoActions.ActionType.LOAD_USER_LOGGED};
  }

  public static loadingUserData() {
    return {type: ApplicationUserInfoActions.ActionType.LOADING_USER_DATA};
  }
  public static loadUserDataCompleted() {
    return {type: ApplicationUserInfoActions.ActionType.LOAD_USER_DATA_COMPLETED};
  }

  public static loginUser() {
    return {type: ApplicationUserInfoActions.ActionType.LOGIN_USER};
  }
}
